import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ActivityData, ActivityId, SubunitData } from 'course-types';
import { Id } from 'lesson-types';

interface SUBUNIT_STATE_TYPE {
  id: Id | undefined;
  name?: string; // TODO: add to DB schema
  index: number;
  activities: Array<ActivityId> | Array<ActivityData>;
}

const INITIAL_STATE: SUBUNIT_STATE_TYPE = {
  id: undefined,
  name: '',
  index: -1,
  activities: [],
};

const subunitSlice = createSlice({
  name: 'subunit',
  initialState: INITIAL_STATE,
  reducers: {
    setSubunitData(state: SUBUNIT_STATE_TYPE, action: PayloadAction<SubunitData & { id: Id }>) {
      state.id = action.payload.id;
      state.name = action.payload.name;
      state.index = action.payload.index;
      state.activities = action.payload.activities;
    },
    setSubunitId(state: SUBUNIT_STATE_TYPE, action: PayloadAction<Id | undefined>) {
      state.id = action.payload;
    },
    setSubunitName(state: SUBUNIT_STATE_TYPE, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    setSubunitActivities(state: SUBUNIT_STATE_TYPE, action: PayloadAction<Array<ActivityData>>) {
      state.activities = action.payload;
    },
  },
});

export const { setSubunitData, setSubunitId, setSubunitName, setSubunitActivities } =
  subunitSlice.actions;

export default subunitSlice.reducer;
